export default __webpack_public_path__ + "static/media/Jrepo2-logo.61ba07fc.png";